import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  MAP_API: string = 'https://maps.googleapis.com/maps/api/js?key='+environment.googleMapsApiKey+'&libraries=places'; 

  loadGoogleMapsAPI() {
    let scripts = Array.from(document.querySelectorAll('script')).map(scr => scr.src);
    if (!scripts.includes(this.MAP_API)) {
      const script = document.createElement('script');
      script.src = this.MAP_API;
      script.defer = true;
      script.async = true;
      document.head.appendChild(script);
    }
  }
}
